export default __webpack_public_path__ + "static/media/P-003.9b252521.png";